



















import Page from "@/components/Page.vue";
import ApiSearch from "@/components/apiSearch/components/ApiSearch.vue";

import Vue from "vue";
import store, { CashStatementStore } from "../services/store";
import { t } from "@/plugins/i18n";

interface Data {
  store: CashStatementStore;
}

interface Methods {
  selected(cashPointID: number): void;
  cancel(): void;
}

export default Vue.extend<Data, Methods, {}, {}>({
  components: {
    Page,
    ApiSearch,
  },

  data: () => ({
    store,
  }),

  methods: {
    selected(cashPointID: number) {
      this.$router.push(`/cash-statement/create/${cashPointID}`);
    },

    cancel() {
      this.$router.push(`/cash-statement`);
    },
  },

  computed: {
    columns: () => [
      { field: "partner", title: t("PartnerNeve") },
      { field: "site", title: t("Telephely") },
      { field: "name", title: t("PenztarNeve") },
      { field: "currency", title: t("Penznem") },
      { field: "accNo", title: t("CashStatement_MaxKivonatSzam") },
      { field: "inDocNo", title: t("CashStatement_MaxKiadasiBizSzam") },
      { field: "outDocNo", title: t("CashStatement_MaxBeveteliBizSzam") },
      { field: "accCode", title: t("CashStatement_PenztarFokonyviSzam") },
    ],
  },
});
